module.exports = __webpack_public_path__ + "img/eugene-golovesov-2prp066F0MU-unsplash.5de17c99.jpg";